export default "__VITE_ASSET__CDCDeFKQ__"